import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/antinuke`;

export const getAntinukeWhitelist = (guildId) => apiRequest(`${base(guildId)}/whitelist`);
export const addAntinukeWhitelist = (guildId, payload) =>
  apiRequest(`${base(guildId)}/whitelist`, { method: "POST", body: payload });
export const editAntinukeWhitelist = (guildId, userId, payload) =>
  apiRequest(`${base(guildId)}/whitelist/${userId}`, { method: "PATCH", body: payload });
export const removeAntinukeWhitelist = (guildId, userId) =>
  apiRequest(`${base(guildId)}/whitelist/${userId}`, { method: "DELETE" });

export const getTrustedAdmins = (guildId) => apiRequest(`${base(guildId)}/trusted-admins`);
export const addTrustedAdmin = (guildId, userId) =>
  apiRequest(`${base(guildId)}/trusted-admins`, { method: "POST", body: { user_id: userId } });
export const removeTrustedAdmin = (guildId, userId) =>
  apiRequest(`${base(guildId)}/trusted-admins/${userId}`, { method: "DELETE" });

export const getExtraOwners = (guildId) => apiRequest(`${base(guildId)}/extraowners`);
export const addExtraOwner = (guildId, userId) =>
  apiRequest(`${base(guildId)}/extraowners`, { method: "POST", body: { user_id: userId } });
export const removeExtraOwner = (guildId, userId) =>
  apiRequest(`${base(guildId)}/extraowners/${userId}`, { method: "DELETE" });

export const getIgnoredChannels = (guildId) => apiRequest(`${base(guildId)}/ignored-channels`);
export const addIgnoredChannel = (guildId, channelId) =>
  apiRequest(`${base(guildId)}/ignored-channels`, { method: "POST", body: { channel_id: channelId } });
export const removeIgnoredChannel = (guildId, channelId) =>
  apiRequest(`${base(guildId)}/ignored-channels/${channelId}`, { method: "DELETE" });
